import { Retainable } from './Retainable';
import debug from 'debug';
const error = debug('core:error');
const warn = debug('core:warn');
function shouldNotifyListener(eventDescription, listener) {
    if (typeof eventDescription === 'string') {
        const eventsArray = Array.isArray(listener.event) ? listener.event : [listener.event];
        return eventsArray.includes(eventDescription) || eventsArray.includes('*');
    }
    else if (typeof eventDescription === 'function') {
        //                      
        return eventDescription(listener.event);
    }
    else {
        //                               
        return false;
    }
}
export class Observable extends Retainable {
    _listeners = [];
    constructor() {
        super();
    }
    _notify(eventDescription, ...args) {
        const listeners = this._listeners.filter(listener => shouldNotifyListener(eventDescription, listener));
        listeners.forEach(listener => {
            if (!this._listeners) {
                //                          
                debugger;
                return;
            }
            if (this._listeners.includes(listener)) {
                //                                            
                try {
                    listener.callback(...args);
                }
                catch (err) {
                    error(`[Observer] Error notifying listener of event "${eventDescription}"`, err);
                }
            }
        });
    }
    subscribe(event, callback) {
        if (!callback) {
            //                        
            return { dispose: () => null };
        }
        const debugInfo = String(new Error().stack)
            .split('\n')
            .slice(2)
            .join('\n');
        const listener = { event, callback, debugInfo };
        this._listeners.push(listener);
        const dispose = () => {
            if (!this._listeners) {
                warn('[Observer] Call dispose an Observable: already destroyed');
                debugger;
                return;
            }
            const idx = this._listeners.indexOf(listener);
            if (idx !== -1) {
                this._listeners.splice(idx, 1);
            }
            else {
                warn('Call dispose an Observable: No such listener');
            }
        };
        return { dispose };
    }
    unsubscribe(callback) {
        if (!callback) {
            //                        
            return false;
        }
        let result = false;
        this._listeners = this._listeners.filter(listener => {
            if (listener.callback === callback) {
                result = true;
                return false;
            }
            else {
                return true;
            }
        });
        return result;
    }
    once(event, listener) {
        let subscription;
        subscription = this.subscribe(event, (arg) => {
            try {
                listener(arg);
            }
            finally {
                subscription.dispose();
                subscription = null;
            }
        });
        return subscription;
    }
    /* 
                                                  
      
             
                                                              
                                                                     
      
                            
                              
     */
    happens(event) {
        return new Promise(resolve => {
            this.once(event, resolve);
        });
    }
    _dispose() {
        if (this._listeners === null) {
            //                  
            debugger;
        }
        this._listeners = null;
    }
}
